import { MenuOptions } from '../../enums/MenuOptions';

export interface MenuItem {
    id: MenuOptions;
    label: string;
    iconClassName: string;
}

export const topMenuItem: MenuItem = {
    id: MenuOptions.Credit,
    label: 'Credit',
    iconClassName: 'fa-kit fa-credits',
};

export const menuItemsOnDemand: MenuItem[] = [
    { id: MenuOptions.Segments, label: 'Segments', iconClassName: 'fa-kit fa-segments', },
    { id: MenuOptions.Materials, label: 'Materials', iconClassName: 'fa-kit fa-materials', },
    { id: MenuOptions.Faculty, label: 'Faculty', iconClassName: 'fa-kit fa-faculty', },
    { id: MenuOptions.Notes, label: 'Notes', iconClassName: 'fa-kit fa-notes', },
    { id: MenuOptions.QandA, label: 'Q&A', iconClassName: 'fa-kit fa-qanda', },
    { id: MenuOptions.Support, label: 'Support', iconClassName: 'fa-kit fa-support', },
];

export const menuItemsOnDemandGroupcast: MenuItem[] = menuItemsOnDemand.filter(i => i.id !== MenuOptions.Notes);

export const menuItemsLive: MenuItem[] = [
    { id: MenuOptions.QandA, label: 'Polls / Q&A', iconClassName: 'fa-kit fa-qanda', },
    { id: MenuOptions.Faculty, label: 'Faculty', iconClassName: 'fa-kit fa-faculty', },
    { id: MenuOptions.Segments, label: 'Schedule', iconClassName: 'fa-kit fa-upcoming', },
    { id: MenuOptions.Materials, label: 'Materials', iconClassName: 'fa-kit fa-materials', },
    { id: MenuOptions.Support, label: 'Support', iconClassName: 'fa-kit fa-support', },
];

// For panels that should still be attached to the menu state, but do not have a visible menu option
export const phantomMenuItems: MenuItem[] = [
    { id: MenuOptions.EndOfVideo, label: '', iconClassName: '' },
    { id: MenuOptions.RequestCredit, label: '', iconClassName: '' },
];